import { render, staticRenderFns } from "./operationGuideDetail.vue?vue&type=template&id=6dc52048&scoped=true"
import script from "./operationGuideDetail.vue?vue&type=script&lang=js"
export * from "./operationGuideDetail.vue?vue&type=script&lang=js"
import style0 from "./operationGuideDetail.vue?vue&type=style&index=0&id=6dc52048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc52048",
  null
  
)

export default component.exports